import { PageTemplateFilter } from '../../templates-next/page-template'


export default PageTemplateFilter
export const { Column } = PageTemplateFilter
